import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "svg-icon-Group",
  "use": "svg-icon-Group-usage",
  "viewBox": "0 0 18 9",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 9\" id=\"svg-icon-Group\"><g fill-rule=\"evenodd\"><path d=\"M6.253 5.373a2.75 2.75 0 1 0 3.394-2.546A2.249 2.249 0 0 1 7.5 5.75c-.46 0-.889-.138-1.247-.377z\" stroke=\"#000\" stroke-width=\"1.5\" fill-rule=\"nonzero\" /><path d=\"M1.845 6.035a1 1 0 0 1-1.69-1.07C2.24 1.678 5.222 0 9 0c3.778 0 6.761 1.678 8.845 4.965a1 1 0 1 1-1.69 1.07C14.435 3.322 12.085 2 9 2S3.565 3.322 1.845 6.035z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol